import * as React from 'react'
import Box from '@material-ui/core/Box'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import MuiAutocomplete from '@material-ui/lab/Autocomplete'
import { AutocompleteChangeReason } from '@material-ui/lab/useAutocomplete/useAutocomplete'

import AvatarIcon from '../../stories/assets/avatar-icon.svg'
import Avatar from '../avatar/Avatar'
import Typography from '../base/Typography'
import { CleanerData } from '../molecules/CardCleaner'
import { TextField } from './Input'

export type StyledCleaner = {
  dataCleaner: CleanerData[]
  loading: boolean
  onSelect: (value: CleanerData) => void
}

export type CleanerSearchProps = StyledCleaner

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 271,
      background: '#F8FAFB',
      border: 'none'
    },
    avatar: {
      marginRight: theme.spacing(2)
    },
    placeholder: {
      '::placeholder': {
        color: '#52798F'
      }
    }
  })
)

export const CleanerSearch: React.FC<CleanerSearchProps> = (props) => {
  const { dataCleaner, loading, onSelect } = props
  const classes = useStyles()
  const onChange = (
    event: any,
    value: any,
    empty: AutocompleteChangeReason
  ): void => {
    if (empty === 'clear') {
      return
    }
    onSelect(value)
  }
  return (
    <MuiAutocomplete
      freeSolo
      disableClearable
      classes={{ root: classes.root }}
      options={dataCleaner}
      getOptionLabel={(option): string => option.name}
      onChange={onChange}
      loading={loading}
      renderOption={(option): React.ReactElement => (
        <Box display="flex" alignItems="center" color="#222" padding={1}>
          <Avatar
            className={classes.avatar}
            imageAvatar
            customSize="medium"
            src={option.imgUrl ? option.imgUrl : AvatarIcon}
          />
          <Typography variant="body2" children={option.name} />
        </Box>
      )}
      renderInput={(params): React.ReactElement => (
        <TextField
          {...params}
          className={classes.placeholder}
          customSize="medium"
          placeholder="Add another cleaner to the list"
          readOnly={false}
          icon="SearchIcon"
          InputProps={{ ...params.InputProps, type: 'search' }}
        />
      )}
    />
  )
}

export default CleanerSearch